/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Map, Record, List } from 'immutable';
import { actionTypes } from '../actions/reports';

export const VersionInfo = new Record(
  {
    active: false,
    version: 0,
  },
  'VersionInfo'
);

export const DataSetVersionInfo = new Record(
  {
    id: 0,
    name: '',
    versionInfoList: new List(),
  },
  'DataSetVersionInfo'
);

export const DataSetVersionReport = new Record(
  {
    id: 0,
    version: 0,
    reportInfoSet: [],
  },
  'DataSestVersionReport'
);

export const AccountMatchReport = new Record(
  {
    orderId: '',
    customerId: '',
    customer: '',
    accountsMatched: '',
    accountsProspected: '',
    contactsMatched: '',
    contactsProspected: '',
    leadsMatched: '',
    leadsProspected: '',
  },
  'AccountMatchReport'
);

export const CustomerRecordMetadata = new Record(
  {
    installationId: '',
    customerRecordId: '',
    parentCustomerRecordId: '',
    recordTypeId: '',
    total: '',
    accountName: '',
    accountAddress1: '',
    accountAddress2: '',
    accountCity: '',
    accountState: '',
    accountZip: '',
    accountPhone: '',
    accountUrl: '',
    accountCountry: '',
    accountSecondaryAddress1: '',
    accountSecondaryAddress2: '',
    accountSecondaryCity: '',
    accountSecondaryState: '',
    accountSecondaryZip: '',
    accountSecondaryCountry: '',
    contactFirstName: '',
    contactLastName: '',
    contactPhone: '',
    contactMobilePhone: '',
    contactEmail: '',
    contactTitle: '',
    contactDepartment: '',
    contactAddress1: '',
    contactAddress2: '',
    contactCity: '',
    contactState: '',
    contactZip: '',
    contactCountry: '',
    contactCompany: '',
    contactSecondaryAddress1: '',
    contactSecondaryAddress2: '',
    contactSecondaryCity: '',
    contactSecondaryState: '',
    contactSecondaryZip: '',
    contactSecondaryCountry: '',
    s3Path: '',
    createdDate: '',
    updatedDate: '',
  },
  'CustomerRecordMetadata'
);

export const OrderMatchReport = new Record(
  {
    matchReport: [],
    seriesData: [],
    fieldGroupsAggs: [],
    customerRecordMetadataAggs: [],
    savedSearches: [],
  },
  'OrderMatchReport'
);

export const MatchedPairReport = new Record(
  {
    status: '',
    csvUrl: '',
  },
  'MatchedPairReport'
);

const reports = new Map({
  datasetVersionInfo: new List(),
  datasetVersionReport: new DataSetVersionReport(),
  report: new List(),
  selectedDataset: new Map(),
  accountMatchReport: new List(),
  orderMatchReport: new OrderMatchReport(),
  matchedPairReport: new MatchedPairReport(),
});

const initialState = reports;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.DATASET_VERSION_INFO_FETCH_SUCCESS: {
      const datasetVersionInfo = new List(
        action.datasetVersionInfo.map(
          info =>
            new DataSetVersionInfo({
              id: info.id,
              name: info.name,
              versionInfoList: new List(
                info.versionInfoList.map(version => new VersionInfo(version))
              ),
            })
        )
      );
      return state.merge({ datasetVersionInfo });
    }
    case actionTypes.DATASET_VERSION_REPORT_FETCH_SUCCESS: {
      const datasetVersionReport = new DataSetVersionReport(action.datasetVersionReport);
      return state.merge({ datasetVersionReport });
    }
    case actionTypes.REPORT_FETCH_SUCCESS: {
      return state.merge({ report: new List(action.reportData) });
    }
    case actionTypes.SET_DATASET_SUCCESS: {
      // const prevSelectedDataset = state.get('selectedDataset');
      const selectedDataset = new Map(action.datasetInfo);
      return state.merge({ selectedDataset });
    }
    case actionTypes.SET_SELECTED_VERSION_SUCCESS: {
      const selectedDataset = state.get('selectedDataset');
      const newDataset = selectedDataset.update('selectedVersion', () => action.version);
      return state.merge({ selectedDataset: newDataset });
    }
    case actionTypes.ACCOUNT_MATCH_REPORT_SUCCESS: {
      return state.merge({ accountMatchReport: new List(action.accountMatchReportData) });
    }
    case actionTypes.ORDER_MATCH_REPORT_SUCCESS: {
      return state.merge({ orderMatchReport: new OrderMatchReport(action.orderMatchReportData) });
    }
    case actionTypes.CLEAR_ORDER_MATCH_REPORT_SUCCESS: {
      return state.merge({ orderMatchReport: new OrderMatchReport() });
    }
    case actionTypes.ORDER_MATCH_REPORT_SERIES_SUCCESS: {
      return state.merge({ orderMatchReportSeries: new List(action.orderMatchReportSeriesData) });
    }
    case actionTypes.ORDER_SAVED_SEARCH_SUCCESS: {
      return state.merge({ orderSavedSearch: new List(action.orderSavedSearchData) });
    }
    case actionTypes.CUSTOMER_RECORD_METADATA_SUCCESS: {
      return state.merge({ customerRecordMetadata: new List(action.customerRecordMetadata) });
    }
    case actionTypes.FIELD_GROUPS_AGG: {
      return state.merge({ fieldGroupsAgg: new List(action.fieldGroupsAgg) });
    }
    case actionTypes.MATCHED_PAIR_REPORT_SUCCESS: {
      return state.merge({ matchedPairReport: new MatchedPairReport(action.matchedPairReportData) });
    }
    case actionTypes.CLEAR_MATCHED_PAIR_REPORT_SUCCESS: {
      return state.merge({ matchedPairReport: new MatchedPairReport() });
    }
    default: {
      return state;
    }
  }
}
